"use client";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import Step1 from "../../components/auth/ForgotPassword/Step1";
import Step4 from "../../components/auth/ForgotPassword/Step4";
import Step3 from "../../components/auth/ForgotPassword/Step3";
import Step2 from "../../components/auth/ForgotPassword/Step2";
import Navbar from "../../components/auth/common/Navbar"

export default function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [tempToken, setTempToken] = useState();

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4 select-none">
      <Navbar />
      <AnimatePresence mode="wait">
        {step === 1 && <Step1 setStep={setStep} setTempToken={setTempToken} />}
        {step === 2 && <Step2 setStep={setStep} tempToken={tempToken} />}
        {step === 3 && <Step3 setStep={setStep} tempToken={tempToken} />}
        {step === 4 && <Step4 />}
      </AnimatePresence>
    </div>
  );
}
